module.exports = __webpack_public_path__ + "static/img/logo_login.a3940c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/_app/wwka/src/assets/image/logo_login.png
// module id = udgA
// module chunks = 63